<template>
  <v-bottom-sheet :hide-overlay="true" :persistent="true" v-model="show" inset>
    <v-progress-linear :active="loading" indeterminate></v-progress-linear>
    <div style="position:relative!important;">
      <v-sheet>
        <v-btn
          style="z-index:20; position:absolute; top:0; right:0;"
          class="mt-1 mr-1"
          @click="
            () => {
              this['Supplier/fetchSuppliers']({ page: this.page });
              $router.push('/supplier');
            }
          "
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card>
          <v-window v-model="windows" vertical>
            <v-window-item value="details">
              <v-list>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Company Name</v-list-item-title>
                    <v-list-item-subtitle>{{ supplier.company_name }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Contact Person</v-list-item-title>
                    <v-list-item-subtitle>{{ supplier.contact_person }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Email Address</v-list-item-title>
                    <v-list-item-subtitle
                      ><a :href="'mailto:' + supplier.email_address">{{
                        supplier.email_address
                      }}</a></v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Contact Numbers</v-list-item-title>
                    <v-list-item-subtitle
                      v-for="(contact_number, index) in supplier.splitContactNumber"
                      v-bind:key="index"
                      ><a :href="'tel:' + contact_number">{{
                        contact_number
                      }}</a></v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Address</v-list-item-title>
                    <v-list-item-subtitle>{{ supplier.address }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Web Address</v-list-item-title>
                    <v-list-item-subtitle>{{ supplier.web_address }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Supplier Code</v-list-item-title>
                    <v-list-item-subtitle>{{ supplier.supplier_code }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-window-item>
            <v-window-item value="products">
              <productlist :products="products" />
            </v-window-item>
            <v-window-item value="rawmaterials">
              <rawmateriallist :rawMaterials="rawMaterials" />
            </v-window-item>
          </v-window>
          <v-card-actions>
            <v-chip class="mx-2" :disabled="windows === 'details'" @click="windows = 'details'">
              Details
            </v-chip>
            <v-chip class="mx-2" :disabled="windows === 'products'" @click="windows = 'products'">
              Products
            </v-chip>
            <v-chip
              class="mx-2"
              :disabled="windows === 'rawmaterials'"
              @click="windows = 'rawmaterials'"
            >
              Raw Materials
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn @click="deleteSupplier" outlined color="red">
              Delete
            </v-btn>
            <v-btn @click="goToEdit" color="indigo" outlined>
              Edit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-sheet>
    </div>
    <confirm ref="confirm"></confirm>
  </v-bottom-sheet>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import productlist from './SupplierShowProductList';
import rawmateriallist from './SupplierShowRawMaterialList';
import confirm from '../../components/Confirm.vue';

export default {
  data: function() {
    return {
      windows: 2,
      contact_number: '',
      splitContactNumber: []
    };
  },
  components: {
    productlist,
    rawmateriallist,
    confirm
  },
  props: {
    show: false,
    page: 0
  },
  beforeMount() {
    if (this.show) {
      this['Supplier/getSupplier']({ id: this.$route.params.id }).finally(() => {
        if (this.supplier.company_name == '') {
          this.$router.push('/supplier');
        }
      });
    }
  },
  computed: {
    ...mapState({
      loading: state => state.Supplier.getSupplierLoading,
      supplier(state) {
        if (typeof state.Supplier.supplier.data == 'undefined') {
          return {
            company_name: '',
            contact_person: '',
            email_address: '',
            contact_number: '',
            address: '',
            web_address: '',
            supplier_code: '',
            products: [],
            splitContactNumber: []
          };
        }
        this.contact_number = state.Supplier.supplier.data.contact_number;
        this.splitContactNumber = !this.contact_number || this.contact_number.split(';');
        //console.log(this.splitContactNumber);
        state.Supplier.supplier.data.splitContactNumber = this.splitContactNumber;
        //console.log(state.Supplier.supplier.data);
        return state.Supplier.supplier.data;
      }
    }),
    products: function() {
      return this.supplier.products;
    },
    rawMaterials: function() {
      return this.supplier.raw_materials;
    }
  },
  methods: {
    ...mapActions(['Supplier/fetchSuppliers', 'Supplier/getSupplier']),
    deleteSupplier() {
      this.$refs.confirm
        .open(
          'Delete Supplier',
          'Are you sure you want to delete supplier ' + this.supplier.company_name + '?',
          { color: '#f44336' }
        )
        .then(confirm => {
          axios
            .delete(`api/v1/supplier/${this.$route.params.id}`)
            .then(response => {
              this.$store.commit('SET_SNACK_BAR', {
                message: 'Supplier deleted...',
                color: 'success'
              });
              this['Supplier/fetchSuppliers']({ page: this.page });
              this.$router.push('/supplier');
            })
            .catch(error => {
              if (error.response.status == 403) {
                this.$store.commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              } else {
                this.$store.commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data.errors['id'][0],
                    color: 'error'
                  },
                  { root: true }
                );
              }
            })
            .finally(() => {});
        });
    },
    goToEdit() {
      this.$router.push(`/supplier/${this.$route.params.id}/edit`);
    }
  }
};
</script>
